import axios from 'axios';
import store from '../store/store'

export default {
    async execute(method, resource) {
        // inject the accessToken for each request
        await store.getters.getPropertyGuid
        await store.getters.getJwtAuthenticationToken
        return axios({
            method,
            headers: {
                Authorization: store.getters.getJwtAuthenticationToken //the token is a variable which holds the token
            },
            url: "/residents/properties/" + store.getters.getPropertyGuid + resource,
        }).then(async req => {
            return req.data
        })
    },
    getProperty() {
        return this.execute('get', ``)
    },
    getPropertyUiConfiguration() {
        return this.execute('get', `/uiConfigurations`)
    }
}
